module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/DK-89c0bd2f47075b6dd087d381fe0c6301.png";